import { useSelector } from 'react-redux';
import { OTHER_DISEASE } from 'utils/constants/disease';
import { getUserCondition } from 'modules/user/utils';

export const useAIAssistant = () => {
  const disease = useSelector(
    (state) => getUserCondition(state?.profile?.data),
  );

  return {
    isAIAssistantShown: disease !== OTHER_DISEASE,
  };
};
